import { messages } from "@dashboard/extensions/messages";
import React from "react";
import { useIntl } from "react-intl";

import { EmptyListState } from "./EmptyListState";

export const EmptyInstalledList = () => {
  const intl = useIntl();

  return <EmptyListState title={intl.formatMessage(messages.noExtensionsInstalled)} />;
};
